 

import React from 'react';  
import './index.css';
 import {
  connect
} from 'react-redux';
 
import {  WhiteSpace } from 'antd-mobile';
import ReportAttach from '../reportAttachment';
import ReportScore from '../reportScore';
import ReportScorePoint from '../reportScorePoint';
import ReportList from '../reportList';
import moment from "moment"; 

class TabReport extends React.Component{
  constructor(props){
    super(props);
    this.state={
      buttonDisabled: true,
      tipes:''
    }
  }
  ratioSize(endDate,startDate,nowDate){
    
    if(endDate<nowDate){
      this.setState({
         buttonDisabled: true,
         tipes:'已过期不能提交'
      })
    }else if(nowDate<startDate){
       this.setState({
         buttonDisabled: true,
         tipes:'未到开始时间不能提交'
      })
    }else{
        this.setState({
         buttonDisabled: false
      })
    }
  }
 

    componentWillReceiveProps(nextProps) {  

    // if (nextProps.endtime !== this.props.endtime) {
      setTimeout(() => { 
    
        const {data,score,endtime,starttime}=this.props;  
        if( score!=='' && score>=0 ){
           this.setState({
            tipes:'老师已经评分不能提交'
          })
        }else{ 
            this.ratioSize(endtime*1000,starttime*1000,new Date().getTime())   
          } 
        }, 600);
    // }
  }
  render(){
   
    const {attachmentList,
      grade_tpl_content,
      score, 
       }=this.props;

    return (
      <div className="tab-report">
        <WhiteSpace/>
        <ReportAttach attachmentList={attachmentList}/>
        <ReportScorePoint data={grade_tpl_content}/>
        {/*<ReportList    */}
        {/*  tips={this.state.tipes}  */}
        {/*  buttonDisabled={ this.state.buttonDisabled}*/}
        {/*/>*/}
        {
          score&&score>=0?
          <ReportScore score={score}/> 
          :null 
        }
      </div>
      )
  }
}
 

 
const mapState = (state) => ({
 
  attachmentList: state.getIn(['labroomexper', 'attachmentList']),
  grade_tpl_content: state.getIn(['labroomexper', 'grade_tpl_content']),
  score: state.getIn(['labroomexper', 'score']),
 
 
})
 
 
 

export default connect(mapState, null)(TabReport);

 
 






 